export enum GeneralErrorCode {
  FORBIDDEN = 'FORBIDDEN',
  SERVER_ERROR = 'SERVER_ERROR',
  ACCESS_FORBIDDEN = 'ACCESS_FORBIDDEN',
  IP_BLOCKED = 'IP_BLOCKED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
